// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import MembershipBusinessListResourceViewModel from '../../../../viewModel/resource/MembershipBusinessListResourceViewModel';
import MembershipBusinessListResourceDTO from '../../dto/resource/MembershipBusinessListResourceDTO';

export default abstract class MembershipBusinessListResourceModel extends BaseModel<MembershipBusinessListResourceDTO> {
  /**
  * @type {uuid}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get isActive() { return this.dto.isActive; }
  set isActive(value) { this.dto.isActive = value; }
  /**
  */
  get name() { return this.dto.name; }
  set name(value) { this.dto.name = value; }
  /**
  */
  get city() { return this.dto.city; }
  set city(value) { this.dto.city = value; }
  /**
  */
  get postalCode() { return this.dto.postalCode; }
  set postalCode(value) { this.dto.postalCode = value; }
  /**
  */
  get categoryName() { return this.dto.categoryName; }
  set categoryName(value) { this.dto.categoryName = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    value = qs.isActive === 'true' ? true : qs.isactive;
    value = qs.isActive === 'false' ? false : undefined;
    this.dto.isActive = value;
    this.dto.name = qs.name;
    this.dto.city = qs.city;
    this.dto.postalCode = qs.postalcode;
    this.dto.categoryName = qs.categoryname;
  }
}
